import { gsap } from "gsap";
import { SplitText } from "gsap/all";

gsap.registerPlugin(SplitText);

export default function(){
	if ( document.querySelector( '.banner--home ' ) ) {
		const bannerTitle      = document.querySelector( '.banner__title' )
		const bannerText       = document.querySelector( '.banner__text' )
		const bannerBackground = document.querySelector( '.banner__background' )
		const bannerVideo      = document.querySelector( '.banner__background video' )
		const bannerIframe     = document.querySelector( '.banner__background iframe' )
		const nextBlock        = document.querySelector( '.homepage-intro' )
		
		let video = bannerIframe

		let clipPathFinal = 'inset( 0% 5% 54% 15% )'

		if ( window.innerWidth < 1084 ) {
			clipPathFinal = 'inset( 0% 0% 45% 10% )'
		}

		if ( window.innerWidth > 827 ) {
			//Starting point
			new SplitText(bannerTitle, { type: "lines" } );
			gsap.set( bannerTitle.querySelectorAll( 'div' ), { clipPath: 'inset( 0% 0% 100% 0% )', y: 100 } )
			gsap.set( bannerText, { opacity: 0 } )
			gsap.set( nextBlock, { opacity: 0 } )
		
			// Start animation and video
			if ( bannerVideo ) {
				bannerVideo.play()
				video = bannerVideo
			}
		
			let bannerTL = gsap.timeline()
	
			bannerTL
				.delay(2)
				.to( bannerTitle.querySelectorAll( 'div' ), { clipPath: 'inset( 0% 0% 0% 0% )', y: 0,  duration: 0.8 })
				.to( bannerBackground, {  clipPath: clipPathFinal, duration: 0.8, ease: "Power1.easeInOut" }, '<' )
				.to( video, {  y: '-20%', duration: 0.8, ease: "Power1.easeInOut" }, '<' )
				.to( bannerText, { opacity: 1 }, '-=0.5' )
				.to( nextBlock, { opacity: 1, y: 0 } )
				//.duration(10)
		} else {
			// Start animation and video
			if ( bannerVideo ) {
				bannerVideo.play()
				video = bannerVideo
			}
		}
		

		const iframe = document.querySelectorAll('.banner__background iframe');

		if ( iframe.length > 0 ) {
			function resizeIframe() {
				const vw = window.innerWidth;
				const vh = window.innerHeight;
	
				const videoAspectRatio = 16 / 9; // Adjust this to match the video's aspect ratio
				const windowAspectRatio = vw / vh;

				iframe.forEach(iframeVideo => {
					if (windowAspectRatio > videoAspectRatio) {
						// The window is wider, adjust iframe height
						const newHeight = vw / videoAspectRatio;
						const topMargin = (vh - newHeight) / 2;
						iframeVideo.style.width = vw + 'px';
						iframeVideo.style.height = newHeight + 'px';
						iframeVideo.style.marginTop = topMargin + 'px';
						iframeVideo.style.marginLeft = '0';
					} else {
						// The window is taller, adjust iframe width
						const newWidth = vh * videoAspectRatio;
						const leftMargin = (vw - newWidth) / 2;
						iframeVideo.style.width = newWidth + 'px';
						iframeVideo.style.height = vh + 'px';
						iframeVideo.style.marginTop = '0';
						iframeVideo.style.marginLeft = leftMargin + 'px';
					}
				});
	
			}

			window.addEventListener('resize', resizeIframe);
			resizeIframe();
		}

	}
}
